/**
 * @generated SignedSource<<8f4b192aeac1f9b52ecdda882b04f807>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type GetTestObjectsQuery$variables = {};
export type GetTestObjectsQuery$data = {
  readonly getTestObjects: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
  }>;
};
export type GetTestObjectsQuery = {
  response: GetTestObjectsQuery$data;
  variables: GetTestObjectsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "TestObject",
    "kind": "LinkedField",
    "name": "getTestObjects",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "GetTestObjectsQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "GetTestObjectsQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "671115591f39bdda6f3f7e91afe6114f",
    "id": null,
    "metadata": {},
    "name": "GetTestObjectsQuery",
    "operationKind": "query",
    "text": "query GetTestObjectsQuery {\n  getTestObjects {\n    id\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "a537883ca9913589a975ad2599ecf0db";

export default node;
